module.exports = __webpack_public_path__ + "img/pic_2.0e2d534b.png";